interface HeaderProps {
  onClose: () => void;
  onBack?: () => void;
  isSandbox?: boolean;
}

export function Header({ onClose, onBack, isSandbox }: HeaderProps) {
  return (
    <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
      <div className="flex items-center gap-2">
        {onBack && (
          <button
            onClick={onBack}
            className="text-gray-400 hover:text-gray-700 -ml-1 mr-1"
            aria-label="Back"
          >
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path d="M12 5L7 10L12 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
        <span className="text-sm font-semibold text-gray-900">SeedLink</span>
        {isSandbox && (
          <span className="px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider bg-gray-100 text-gray-600 border border-gray-300">
            Sandbox
          </span>
        )}
      </div>
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-gray-700"
        aria-label="Close"
      >
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}
